import request from '@/utils/request'

// 获取章节试卷试题
export function getChapterPaper(courseId, chapterId) {
    return request({
        url: '/hdjg/exam/paper/get/paper?courseId=' + courseId + '&chapterId=' + chapterId,
        method: 'get'
    })
}

export function getAllQuizPaper(courseId) {
    return request({
        url: '/hdjg/exam/paper/get/all/quiz/paper?courseId=' + courseId,
        method: 'get'
    })
}

// 获取测试试卷试题
export function getQuizPaperQuestion(paperId) {
    return request({
        url: '/hdjg/exam/paper/get/quiz/paper/question?paperId=' + paperId,
        method: 'get'
    })
}


// 创建答题卷
export function createPaperAnswer(data) {
    return request({
        url: '/hdjg/paper/answer/create',
        method: 'post',
        data: data
    })
}

export function createQuizPaperAnswer(data) {
    return request({
        url: '/hdjg/paper/answer/create/quiz',
        method: 'post',
        data: data
    })
}

// 获取章节错题
export function getChapterPaperWrongQuestion(courseId, chapterId, userId) {
    return request({
        url: '/hdjg/exam/paper/get/wrong/paper?courseId=' + courseId + '&chapterId=' + chapterId + '&userId=' + userId,
        method: 'get'
    })
}

// 获取所有答题记录
export function getPaperAnswerRecordPage(params) {
    return request({
        url: '/hdjg/paper/answer/get/paper/record/page',
        method: 'get',
        params
    })
}

// 获取试卷报告
export function getPaperReport(id) {
    return request({
        url: '/hdjg/paper/answer/get/paper/report?id=' + id,
        method: 'get',
    })
}

// 获取所有错题
export function getMistakePage(params) {
    return request({
        url: '/hdjg/question/answer/mistake/page',
        method: 'get',
        params
    })
}
